import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "babySeat"
const BabySeatIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M12 15.188C12.725 15.188 13.313 15.775 13.313 16.5S12.725 17.813 12 17.813 10.688 17.225 10.688 16.5 11.275 15.188 12 15.188M8.625 10.313C8.895 10.313 9.165 10.366 9.415 10.469S9.892 10.725 10.083 10.917C10.275 11.108 10.427 11.335 10.531 11.585 10.634 11.835 10.687 12.105 10.687 12.375H9.564Q9.563 12.189 9.49 12.016 9.42 11.844 9.288 11.712 9.156 11.581 8.984 11.51 8.81 11.437 8.625 11.437T8.266 11.51Q8.094 11.58 7.962 11.712 7.831 11.844 7.76 12.016 7.687 12.19 7.687 12.375H6.563C6.563 12.105 6.617 11.835 6.72 11.585S6.975 11.108 7.167 10.917C7.358 10.725 7.585 10.573 7.835 10.469 8.085 10.366 8.355 10.313 8.625 10.313M15 10.313C15.27 10.313 15.54 10.366 15.79 10.469S16.267 10.725 16.458 10.917C16.65 11.108 16.802 11.335 16.906 11.585 17.009 11.835 17.063 12.105 17.063 12.375H15.938Q15.938 12.189 15.866 12.016 15.795 11.844 15.664 11.712 15.53 11.581 15.359 11.51 15.186 11.437 15 11.437T14.641 11.51Q14.47 11.58 14.337 11.712 14.206 11.844 14.134 12.016 14.062 12.19 14.062 12.375H12.939C12.938 12.105 12.99 11.835 13.094 11.585S13.35 11.108 13.542 10.917C13.733 10.725 13.96 10.573 14.21 10.469 14.46 10.366 14.73 10.313 15 10.313" />
          <path
            fillRule="evenodd"
            d="M12.105 3.001 12.115 3.002C15.947 3.05 19.197 5.492 20.448 8.898 21.654 9.413 22.5 10.605 22.5 12S21.653 14.585 20.45 15.1C19.185 18.542 15.881 21 12 21S4.812 18.542 3.55 15.1C2.345 14.585 1.5 13.394 1.5 12S2.346 9.413 3.55 8.898C4.814 5.457 8.118 3 12 3zM11.982 4.5C8.648 4.508 5.825 6.692 4.857 9.708L4.736 10.088 4.352 10.2C3.57 10.426 3 11.147 3 12 3 12.852 3.57 13.573 4.352 13.8L4.736 13.91 4.857 14.292C5.827 17.313 8.658 19.5 12 19.5S18.173 17.313 19.142 14.291L19.263 13.911 19.647 13.8C20.43 13.573 21 12.852 21 12S20.43 10.426 19.647 10.2L19.263 10.088 19.142 9.708C18.43 7.491 16.716 5.724 14.533 4.94Q14.631 5.302 14.624 5.678C14.614 6.152 14.477 6.615 14.226 7.017 13.974 7.419 13.619 7.745 13.196 7.96 12.776 8.178 12.303 8.275 11.83 8.244 11.356 8.214 10.9 8.055 10.51 7.786S9.81 7.147 9.612 6.716L10.977 6.092C11.06 6.277 11.194 6.436 11.36 6.552 11.53 6.667 11.724 6.735 11.927 6.748S12.332 6.718 12.513 6.626 12.846 6.393 12.953 6.221C13.062 6.05 13.122 5.851 13.126 5.648S13.078 5.244 12.977 5.068C12.877 4.89 12.73 4.746 12.553 4.646 12.379 4.547 12.182 4.496 11.982 4.5"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default BabySeatIcon
